<!--人文美育-视频库管理-->
<template>
    <div class="app-container" >
        <div class="base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1766638364292" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6637" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="6638"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="6639" data-spm-anchor-id="a313x.search_index.0.i1.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{!courseId?'创建课程':'编辑课程'}}</div>
            </div>
            <!--基本信息-->
            <div class="info-container">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <div class="info-column-container">
                        <div class="column-title">基本信息</div>
                    </div>
                    <div class="info-content-container">
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                基础信息
                            </div>
                        </div>
                        <el-row>
                            <el-col :span="15">
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="课程名称" prop="courseName">
                                            <el-input v-model="form.courseName" placeholder="请输入课程名称，最多50个字" maxlength="50" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10">
                                        <el-form-item label="所属五馆" prop="museumKey">
                                            <el-select v-model="form.museumKey" placeholder="请选择所属馆">
                                                <el-option v-for="item in museumList" :key="item.dictKey" :label="item.dictValue"
                                                           :value="item.dictKey" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="课程简介" prop="introduction">
                                            <el-input type="textarea" maxlength="1000"
                                                      rows="5"
                                                      placeholder="课程简介"
                                                      v-model="form.introduction" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="" prop="raceCover">
                                    <el-upload class="avatar-uploader"
                                               :action="serviceUrl+'/businessservice/humanityCourse/uploadCover'" :show-file-list="false"
                                               :on-success="handleCoverSuccess" :headers="{ token }" :before-upload="beforeAvatarUpload">
                                        <img alt="" v-if="form.courseCover" :src="form.courseCover" class="avatar" style="position:absolute" />
                                        <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                            <Plus />
                                        </el-icon>
                                    </el-upload>
                                    <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="topic-title-container">
                            <div class="topic-title-container1">
                                <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#ff7f2e" p-id="12410"></path></svg>
                            </div>
                            <div class="topic-title-container2">
                                关联视频
                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">社会主义先进文化</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(1)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList1&&vList1.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList1" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,1)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">革命文化</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(2)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList2&&vList2.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList2" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,2)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">中华优秀传统文化世界优秀文化遗产</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(3)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList3&&vList3.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList3" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,3)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>


                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">法治意识</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(4)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList4&&vList4.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList4" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,4)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">国家安全</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(5)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList5&&vList5.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList5" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,5)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">民族团结</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(6)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList6&&vList6.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList6" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,6)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">生态文明</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(7)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList7&&vList7.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList7" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,7)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">海洋权益</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(8)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList8&&vList8.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList8" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,8)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>
                    <el-row>
                        <div class="video-title-container">
                            <div>
                                <svg style="margin-top: 5px;" t="1755658273558" class="icon" viewBox="0 0 1365 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5518" width="20" height="20"><path d="M256.006827 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0zM554.671502 383.147526c0-23.039846 16.213225-33.279778 37.546417-23.039847l227.838481 114.345905c41.813055 21.333191 40.959727 55.466297 0 75.94616l-33.279778 17.066553-193.705376 96.426024c-21.333191 10.239932-38.399744 0-38.399744-23.039847z" fill="#ff7f2e" p-id="5519"></path><path d="M0.008533 384.000853A41.813055 41.813055 0 0 1 41.821588 341.334471h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294A42.666382 42.666382 0 0 1 0.008533 384.000853zM0.008533 639.999147A41.813055 41.813055 0 0 1 41.821588 597.332764h255.998293a42.666382 42.666382 0 0 1 43.51971 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294A42.666382 42.666382 0 0 1 0.008533 639.999147zM1024.001707 384.000853a41.813055 41.813055 0 0 1 41.813054-42.666382h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666382 41.813055 41.813055 0 0 1-41.813054 42.666383h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666383zM1024.001707 639.999147a41.813055 41.813055 0 0 1 41.813054-42.666383h255.998294a42.666382 42.666382 0 0 1 41.813054 42.666383 41.813055 41.813055 0 0 1-41.813054 42.666382h-255.998294a42.666382 42.666382 0 0 1-41.813054-42.666382z" fill="#ff7f2e" p-id="5520"></path><path d="M1024.001707 42.669796a42.666382 42.666382 0 1 1 85.332764 0v938.660408a42.666382 42.666382 0 1 1-85.332764 0z" fill="#ff7f2e" p-id="5521"></path><path d="M1262.933447 0.003413H102.407851A101.54599 101.54599 0 0 0 0.008533 101.549403v820.047866A103.252645 103.252645 0 0 0 102.407851 1023.996587h1160.525596a101.54599 101.54599 0 0 0 102.399318-101.54599V101.549403A103.252645 103.252645 0 0 0 1262.933447 0.003413z m17.066553 870.394198a68.266212 68.266212 0 0 1-67.412884 68.266211H152.754182a68.266212 68.266212 0 0 1-67.412884-68.266211V153.602389a68.266212 68.266212 0 0 1 67.412884-68.266211h1059.832934a68.266212 68.266212 0 0 1 67.412884 68.266211z" fill="#ff7f2e" p-id="5522"></path></svg>
                            </div>
                            <div class="video-title">经济社会发展新变化科学技术进步新发展</div>
                            <div class="video-btn">
                                <el-button type="primary" size="small" style="background-color: #ff7f2e;color: #fff;" @click="addVideo(9)">添加视频</el-button>
                            </div>
                        </div>
                    </el-row>
                    <div class="v-list-container" v-if="vList9&&vList9.length>0">
                        <div class="v-list-item" v-for="(item,index) in vList9" :key="index">
                            <div class="video-cover" @click="viewVideo(item)">
                                <img alt="" :src="item.coverUrl" class="img-100">
                            </div>
                            <div class="v-t">
                                <div class="v-t-l">{{item.title}}</div>
                                <div class="v-t-r">
                                    <img alt="" @click="delVideo(item,9)" class="img-100" src="../../assets/icon/img/v-del.png">
                                </div>

                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:215px;'">
                <el-button @click="backList">取 消</el-button>
                <el-button type="primary" @click="submitCourseForm">确 认</el-button>
            </div>
        </div>
    </div>

    <el-dialog class="ve-dialog" :title="'选择视频'" v-model="isSelVideoShow" top="4vh" width="835px">
        <div class="sel-video-contain">
            <!--目录-->
            <div class="l-container">
                <div class="l-second-container">
                    <div class="second-box1">
                        <svg t="1755139711785" style="margin-top: 5px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17744" width="16" height="16"><path d="M0 1024V128h256V0h128v128h256V0h128v128h256v896H0zM924.384 227.616H99.616v696.768h824.768V227.616z m-578.048 185.6l125.12 349.152h-83.2l-23.104-71.84H234.496l-23.136 71.84H128l125.12-349.152h93.216z m-1.952 213.696l-44.64-138.336-44.608 138.336h89.248z m235.648 66.048h106.496v69.408H512V413.12h68.032v279.744z m192 0h106.528v69.408H704V413.12h68.032v279.744z" fill="#ff7f2e" p-id="17745"></path></svg>
                    </div>
                    <div class="second-box2 cursor" @click="handleAllVideo">所有视频</div>
                    <div class="second-box3 cursor" @click="handleAllVideo">{{categoryTreeData.videoNum}}</div>
                </div>
                <el-scrollbar class="l-tree-container">
                    <el-tree
                      :data="categoryList"
                      :show-expand="true"
                      style="max-width: 240px;"
                      @node-click="handleNodeClick">
                        <template #default="{ node, data }">
                            <div class="custom-tree-node" :title="charConversion(data.categoryName)">
                                <span>
                                    <i>
                                        <svg t="1755142425021" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20345" width="16" height="16"><path d="M861.9 843.5c0 31.1-25.2 56.2-56.2 56.2H103.5l98.3-454.2c0-31 25-56.2 56.1-56.2h646.2c31 0 56.1 25.2 56.1 56.2l-98.3 398zM215.8 347.1h632v-55.2c0-31-25.2-56.2-56.2-56.2h-337v-50.9c0-31-25.2-56.2-56.2-56.2H117.6c-31 0-56.2 25.2-56.2 56.2v658.6l98.2-440.2c0-30.9 25.2-56.1 56.2-56.1z m0 0" p-id="20346" fill="#e99d42"></path></svg>
                                    </i>
                                    <span>{{charConversion(data.categoryName)}}</span>
                                </span>
                                <div>
                                    <el-button type="primary" style="color: #606266;margin-left: 5px;" link>{{data.videoNum}}</el-button>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </el-scrollbar>
            </div>
            <div class="r-container">
                <div class="form-box">
                    <el-row style="height: 40px!important;">
                        <el-col :span="24">
                            <el-form-item>
                                <el-input v-model="queryParams.title" placeholder="请输入视频名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="handleQuery" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-scrollbar class="vl-container">
                    <div class="video-box">
                        <div class="video-item" v-for="item in videoList">
                            <div class="item-p1">
                                <div class="video-cover">
                                    <img alt="" :src="item.coverUrl" class="img-100">
                                </div>
                                <div :class="selVId&&selVId.includes(item.videoId)?'video-name-c':'video-name'"  @click="selVideo(item)">
                                    <svg v-if="selVId&&selVId.includes(item.videoId)"  t="1755674519412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9201" width="13" height="13"><path d="M196.923077 0h630.153846a196.923077 196.923077 0 0 1 196.923077 196.923077v630.153846a196.923077 196.923077 0 0 1-196.923077 196.923077H196.923077a196.923077 196.923077 0 0 1-196.923077-196.923077V196.923077a196.923077 196.923077 0 0 1 196.923077-196.923077z m0 78.769231a118.153846 118.153846 0 0 0-118.153846 118.153846v630.153846a118.153846 118.153846 0 0 0 118.153846 118.153846h630.153846a118.153846 118.153846 0 0 0 118.153846-118.153846V196.923077a118.153846 118.153846 0 0 0-118.153846-118.153846H196.923077z m584.900923 258.205538a36.509538 36.509538 0 0 1 1.260308 51.633231l-299.480616 313.107692c-0.118154 0.157538-0.393846 0.236308-0.630154 0.472616l-0.393846 0.551384c-2.166154 2.126769-4.726154 3.229538-7.207384 4.726154-1.575385 0.866462-2.796308 2.166154-4.411077 2.835692a35.800615 35.800615 0 0 1-27.490462 0.07877c-1.260308-0.512-2.284308-1.614769-3.544615-2.284308-2.756923-1.457231-5.592615-2.835692-8.034462-5.12-0.196923-0.157538-0.275692-0.433231-0.512-0.669538-0.196923-0.118154-0.393846-0.196923-0.551384-0.354462l-150.843077-156.593231a36.430769 36.430769 0 0 1 0.945231-51.633231 36.391385 36.391385 0 0 1 51.63323 0.945231l124.455385 129.102769 273.092923-285.61723a36.548923 36.548923 0 0 1 51.712-1.181539z" p-id="9202" fill="#ff7f2e"></path></svg>
                                    <svg v-if="!(selVId&&selVId.includes(item.videoId))"  t="1755674519412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9201" width="13" height="13"><path d="M196.923077 0h630.153846a196.923077 196.923077 0 0 1 196.923077 196.923077v630.153846a196.923077 196.923077 0 0 1-196.923077 196.923077H196.923077a196.923077 196.923077 0 0 1-196.923077-196.923077V196.923077a196.923077 196.923077 0 0 1 196.923077-196.923077z m0 78.769231a118.153846 118.153846 0 0 0-118.153846 118.153846v630.153846a118.153846 118.153846 0 0 0 118.153846 118.153846h630.153846a118.153846 118.153846 0 0 0 118.153846-118.153846V196.923077a118.153846 118.153846 0 0 0-118.153846-118.153846H196.923077z m584.900923 258.205538a36.509538 36.509538 0 0 1 1.260308 51.633231l-299.480616 313.107692c-0.118154 0.157538-0.393846 0.236308-0.630154 0.472616l-0.393846 0.551384c-2.166154 2.126769-4.726154 3.229538-7.207384 4.726154-1.575385 0.866462-2.796308 2.166154-4.411077 2.835692a35.800615 35.800615 0 0 1-27.490462 0.07877c-1.260308-0.512-2.284308-1.614769-3.544615-2.284308-2.756923-1.457231-5.592615-2.835692-8.034462-5.12-0.196923-0.157538-0.275692-0.433231-0.512-0.669538-0.196923-0.118154-0.393846-0.196923-0.551384-0.354462l-150.843077-156.593231a36.430769 36.430769 0 0 1 0.945231-51.633231 36.391385 36.391385 0 0 1 51.63323 0.945231l124.455385 129.102769 273.092923-285.61723a36.548923 36.548923 0 0 1 51.712-1.181539z" p-id="9202" fill="#b1b1b1"></path></svg>
                                    {{item.title}}
                                </div>
                            </div>
                            <div class="item-p2">
                                <div class="player-container">
                                    <div class="player-container">
                                        <img alt="" @click="viewVideo(item)" class="img-100" src="../../assets/icon/img/player.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-scrollbar>
            </div>
        </div>
        <div class="sel-info-contain">
            <div class="info-item1">已选中<span style="color: #ff7f2e;font-weight: bold">{{vNum}}</span>条视频</div>
            <div class="info-item2"> <el-button @click="isSelVideoShow = !isSelVideoShow">取 消</el-button></div>
            <div class="info-item3"><el-button type="primary" @click="isSelVideoShow = !isSelVideoShow">确 认</el-button></div>
        </div>
    </el-dialog>

    <el-dialog class="ar-dialog" :title="videoName" v-model="isViewVideoShow"
               top="8vh"
               width="830px" @close="destroyed">
        <div id="player"></div>
    </el-dialog>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/public";
import {orgListTree} from "@/api/admin/system";
import {listHumanityVideo, treeCategory} from "@/api/admin/humanity";
import {createHumanityCourse,updateHumanityCourse,infoHumanityCourse} from "@/api/admin/humanityCourse";
import {ElLoading} from "element-plus";
import {charConversion} from "@/utils/str";

export default {
    name: "humanityCourseCreate",
    components: {},
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            treeData: [],
            commonSwitch: true,
            isSelVideoShow:false,
            isViewVideoShow:false,
            courseId:'',
            museumList:[],
            form:{
                courseId:'',
                courseName:'',
                courseCover:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png',
                museumKey:'',
                introduction:'',
                // vList1:[], //社会主义先进文化
                // vList2:[], //革命文化
                // vList3:[], //中华优秀传统文化世界优秀文化遗产
                // vList4:[], //法治意识
                // vList5:[], //国家安全
                // vList6:[], //民族团结
                // vList7:[], //生态文明
                // vList8:[], //海洋权益
                // vList9:[], //经济社会发展新变化科学技术进步新发展
            },
            rules: {
                courseName: [{ required: true, message: "请输入课程名称", trigger: "blur" },],
                museumKey: [{ required: true, message: "请选择所属馆", trigger: "change" },],
                introduction: [{ required: true, message: "请输入课程简介", trigger: "blur" },],
            },
            queryParams:{
                title: '',
                categoryId: '',
                isTag: '',
                isCourse: '',
            },
            categoryTreeList:{},
            categoryTreeData:{},
            categoryList:[],
            videoList:[],
            vNo:0,
            vNum:0,
            selVId:'',
            vList1:[], //社会主义先进文化
            vList2:[], //革命文化
            vList3:[], //中华优秀传统文化世界优秀文化遗产
            vList4:[], //法治意识
            vList5:[], //国家安全
            vList6:[], //民族团结
            vList7:[], //生态文明
            vList8:[], //海洋权益
            vList9:[], //经济社会发展新变化科学技术进步新发展
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryDict();
        this.queryOrgListTree();
        this.queryVideoList();
        this.queryTreeCategory();
    },
    mounted(){
        if (this.$route.query.courseId) {
            this.courseId = this.$route.query.courseId
            this.queryCourseInfo()
        }
    },
    methods: {
        charConversion,
        queryDict() {
            queryDict({ code: 'museum_info' }).then(res => {
                if (res.data.code === 1) {
                    this.museumList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.form.courseCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeAvatarUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type === 'image/jpeg' ||
              rawFile.type === 'image/png' ||
              rawFile.type === 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.form.courseCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        backList(){
            this.$router.push({
                path: "/humanityCourseManager",
            });
        },
        queryOrgListTree() {
            orgListTree().then(res => {
                res.data.data.forEach(e => {
                    e.value = e.orgId
                    e.orgName = e.orgName
                    if (e.childrenList && e.childrenList != null) {
                        e.children = e.childrenList;
                        e.children.forEach(m => {
                            m.value = m.orgId
                            m.orgName = m.orgName
                            if (m.childrenList && m.childrenList != null) {
                                m.children = m.childrenList;
                                m.children.forEach(j => {
                                    j.value = j.orgId
                                    j.orgName = j.orgName
                                })
                            }
                        })
                    }
                })
                this.treeData = res.data.data;
            })
        },
        queryVideoList(){
            listHumanityVideo(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.videoList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        addVideo(no){
            this.vNo = no;
            this.selVId = '';
            let list = [];
            if (this.vNo === 1){
                list = this.vList1;
            }
            if (this.vNo === 2){
                list = this.vList2;
            }
            if (this.vNo === 3){
                list = this.vList3;
            }
            if (this.vNo === 4){
                list =this.vList4;
            }
            if (this.vNo === 5){
                list = this.vList5;
            }
            if (this.vNo === 6){
                list = this.vList6;
            }
            if (this.vNo === 7){
                list = this.vList7;
            }
            if (this.vNo === 8){
                list = this.vList8;
            }
            if (this.vNo === 9){
                list =this.vList9;
            }
            if (list&&list.length>0){
                list.forEach(i  =>{
                    this.selVId = this.selVId+i.videoId+','
                })
            }
            this.vNum = list.length;
            this.isSelVideoShow = true;
        },
        queryTreeCategory(){
            treeCategory().then(res => {
                if (res.data.code===1){
                    if (res.data.data){
                        this.categoryTreeList= res.data.data;
                        this.categoryTreeData = this.categoryTreeList[0];
                        this.categoryList = this.categoryTreeData.children;
                    }
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleAllVideo(){
            this.queryParams.categoryId='';
            this.queryVideoList();
        },
        handleNodeClick(e, i){
            this.queryParams.categoryId=e.categoryId;
            this.queryVideoList();
        },
        handleQuery(){
            this.queryVideoList();
        },
        viewVideo(row){
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                width: this.videoWidth,
                height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
            this.isViewVideoShow = false;
        },
        selVideo(item){
            debugger
            // 添加
            if (!this.selVId.includes(item.videoId)){
                this.selVId = this.selVId+item.videoId+",";
                this.handleListAddVideo(item)
            }else {
                this.selVId = this.selVId.replace(item.videoId+",", '');
                this.handleListDelVideo(item)
            }
        },
        handleListAddVideo(item){
            if (this.vNo === 1){
                this.vList1.push(item)
                this.vNum = this.vList1.length;
            }
            if (this.vNo === 2){
                this.vList2.push(item)
                this.vNum = this.vList2.length;
            }
            if (this.vNo === 3){
                this.vList3.push(item)
                this.vNum = this.vList3.length;
            }
            if (this.vNo === 4){
                this.vList4.push(item)
                this.vNum = this.vList4.length;
            }
            if (this.vNo === 5){
                this.vList5.push(item)
                this.vNum = this.vList5.length;
            }
            if (this.vNo === 6){
                this.vList6.push(item)
                this.vNum = this.vList6.length;
            }
            if (this.vNo === 7){
                this.vList7.push(item)
                this.vNum = this.vList7.length;
            }
            if (this.vNo === 8){
                this.vList8.push(item)
                this.vNum = this.vList8.length;
            }
            if (this.vNo === 9){
                this.vList9.push(item)
                this.vNum = this.vList9.length;
            }
        },
        delVideo(item,num){
            this.vNo = num;
            this.handleListDelVideo(item);
        },
        handleListDelVideo(item){
            if (this.vNo === 1){
                this.vList1 = this.vList1.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList1.length;
            }
            if (this.vNo === 2){
                this.vList2 = this.vList2.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList2.length;
            }
            if (this.vNo === 3){
                this.vList3 = this.vList3.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList3.length;
            }
            if (this.vNo === 4){
                this.vList4 = this.vList4.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList4.length;
            }
            if (this.vNo === 5){
                this.vList5 = this.vList5.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList5.length;
            }
            if (this.vNo === 6){
                this.vList6 = this.vList6.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList6.length;
            }
            if (this.vNo === 7){
                this.vList7 = this.vList7.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList7.length;
            }
            if (this.vNo === 8){
                this.vList8 = this.vList8.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList8.length;
            }
            if (this.vNo === 9){
                this.vList9 = this.vList9.filter(v => v.videoId !== item.videoId);
                this.vNum = this.vList9.length;
            }
        },
        submitCourseForm(){
            if (this.vList1.length===0&&this.vList2.length===0&&this.vList3.length===0&&
              this.vList4.length===0&&this.vList5.length===0&&this.vList6.length===0&&
              this.vList7.length===0&&this.vList8.length===0&&this.vList9.length===0){
                this.$message.error("请选择视频");
                return;
            }
            this.form.videoInfo1 = this.vList1;
            this.form.videoInfo2 = this.vList2;
            this.form.videoInfo3 = this.vList3;
            this.form.videoInfo4 = this.vList4;
            this.form.videoInfo5 = this.vList5;
            this.form.videoInfo6 = this.vList6;
            this.form.videoInfo7 = this.vList7;
            this.form.videoInfo8 = this.vList8;
            this.form.videoInfo9 = this.vList9;

            this.$refs["form"].validate(valid => {
                if (valid) {
                    const loading = ElLoading.service({fullscreen: true})
                    if (this.courseId) {
                        updateHumanityCourse(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.backList()
                                loading.close()
                            } else {
                                this.$message.error("操作失败")
                                loading.close()
                            }
                        })
                    }else {
                        createHumanityCourse(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.backList()
                                loading.close()
                            } else {
                                this.$message.error("操作失败")
                                loading.close()
                            }
                        })
                    }
                }
            })
        },
        queryCourseInfo(){
            infoHumanityCourse({ courseId: this.courseId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    this.vList1 = this.form.videoInfo1;
                    this.vList2 = this.form.videoInfo2;
                    this.vList3 = this.form.videoInfo3;
                    this.vList4 = this.form.videoInfo4;
                    this.vList5 = this.form.videoInfo5;
                    this.vList6 = this.form.videoInfo6;
                    this.vList7 = this.form.videoInfo7;
                    this.vList8 = this.form.videoInfo8;
                    this.vList9 = this.form.videoInfo9;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },

    }
}

</script>

<style scoped>
.base-create-container{
    width: 100%;
    max-height: calc(100vh - 130px);
    background-color: #fff;
    //padding-bottom: 70px;
    overflow-y: auto!important;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 40px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 40px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.info-container{
    width: 100%;
    height: auto;
    padding: 5px 10px 10px 10px;
    box-sizing: border-box;
}
.info-content-container{
    width: 100%;
    height: auto;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #ff7f2e;
}
.column-title{
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #ff7f2e;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.topic-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1{
    width: 30px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 10px;
}
.topic-title-container2{
    width: 110px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}
.topic-title-container3{
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #ff7f2e;
}
.video-title-container{
    width: 100%;
    height: 30px;
    padding-left: 30px;
    box-sizing: border-box;
    display: flex;
}
.video-title{
    height: 30px;
    width: 300px;
    line-height: 30px;
    font-size: 15px;
    padding-left: 5px;
    padding-right: 5px;
    color: #ff7f2e;
    font-family: sans-serif;
    font-weight: 600;
}
.video-btn{
    margin-top: 2px;
}
.empty-container{
    width: 70%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-family: sans-serif;
    color: #767676;
    font-size: 15px;
}
.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}
.avatar-uploader /deep/ .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}

.sel-video-contain{
    width: 800px;
    height: 75vh;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    display: flex;
}
.sel-info-contain{
    width: 800px;
    padding-top: 10px;
    height: 40px;
    display: flex;
}
.info-item1{
    width: calc(100% - 140px);
    height: 40px;
    line-height: 40px;
    font-family: sans-serif;

}
.info-item2{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
}
.info-item3{
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-family: sans-serif;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 5px;
    margin-left: 20px;
}
.l-container{
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    border-right: 1px solid #dcdfe6;
}
.l-second-container{
    width: 100%;
    height: 30px;
    padding: 0 10px 0 0;
    line-height: 30px;
    box-sizing: border-box;
    display: flex;
}
.second-box1{
    width: 20px;
}
.second-box2{
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;
}
.second-box3{
    width: calc(100% - 120px);
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;

}
.l-tree-container{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.custom-tree-node{
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.form-box{
    padding-top: 10px;
}
.r-container{
    width: calc(100% - 260px);
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.vl-container{
    width: 100%;
    height: calc(100% - 60px);
}
.video-box{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
}
.video-item{
    width: 33%;
    height: 145px;
    padding: 0 5px 0 5px;
    box-sizing: border-box;
    cursor: pointer;
}
.item-p1{
    width: 100%;
    height: 100%;
    //position: relative;
    z-index: 1;
}
.item-p2{
    width: 100%;
    height: 100%;
    z-index: 2;
    margin-top: -145px;
    padding-top: 30px;
    box-sizing: border-box;
}
.player-container{
    width: 40px;
    height: 40px;
    margin: auto;
}
.video-cover{
    width: 100%;
    height: 100px;
}
.video-name{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #b1b1b1;
    padding-top: 5px;
}
.video-name-c{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #ff7f2e;
    padding-top: 5px;
}
.v-list-container{
    width: 100%;
    height: auto;
    padding: 10px 10px 10px 30px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.v-list-item{
    width: 15%;
    height: 120px;
    padding: 0 10px 10px 10px;
    cursor: pointer;
}
.v-t{
    width: 100%;
    height: 30px;
    display: flex;
    padding-top: 5px;
}
.v-t-l{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    color: #121212;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
.v-t-r{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
</style>